import React, { useMemo } from 'react';
import { FunctionComponent } from 'react';
import { ITaskAvatarParams } from './types';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { meetingSelectors } from '../../../../../../../app/resource/meeting/meeting.selectors';
import { userSelectors } from '../../../../../../../app/resource/user/user.selectors';
import { Tooltip } from '../../../../../../common/Tooltip';
import { CircularAvatar } from '../../../../CustomAvatar';
import { isMemberPartOfMeeting, isMemberActiveInWorkspace } from '../../../../../../../utils/user.utils';
import { meetingSimpleSelectors } from '../../../../../../../app/resource/meeting-simple/meeting-simple.selectors';

export const TaskAvatar: FunctionComponent<ITaskAvatarParams> = ({
  meetingIds,
  currentMeetingId,
  userIds,
  taskType,
}) => {
  const meetings = useSelectWithParams(meetingSelectors.selectResourcesById, meetingIds);
  const currentMeeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, currentMeetingId ?? '');
  const users = useSelectWithParams(userSelectors.selectResourcesById, userIds);
  const images = useMemo(
    () => (taskType === 'rock' ? meetings.map((meetings) => meetings?.image) : users.map((users) => users?.image)),
    [taskType, meetings, users],
  );

  const user = users[0];
  const name = `${user?.firstName} ${user?.lastName}`;

  return (
    <div className="card-footer">
      <div className="group-stack mr-1">
        <span className="btn-badge white-bg f-1">
          <Tooltip content={name} direction="top" bgColor="#13ac92" textColor="white" key={users[0]?.id}>
            <CircularAvatar
              src={images[0]}
              title={name}
              size="35"
              classes={
                user &&
                currentMeeting &&
                (!isMemberPartOfMeeting(user, currentMeeting) || !isMemberActiveInWorkspace(user))
                  ? 'deleted-user'
                  : ''
              }
            />
          </Tooltip>
        </span>
      </div>
      <div className="blueGray f-1"></div>
    </div>
  );
};
